import { FC } from 'react'
import { useSelector } from 'react-redux'
import { platformSettingsSlice } from '@wellesley/settings/slices/platformSettingsSlice'
import useFetchPlatformSettings from '@wellesley/settings/hooks/useFetchPlatformSettings'
import { instanceLegalSettingsKeys } from '@wellesley/settings/keys'

import { Markdown } from './Markdown'

export const TermsMarkdown: FC = () => {
  useFetchPlatformSettings(instanceLegalSettingsKeys)
  const legal = useSelector(platformSettingsSlice.selectors.selectLegal)

  const termsOfUseText = legal?.termsOfUse ?? ''

  return <Markdown markdown={termsOfUseText} footNotePrefix="footnote-terms-" />
}
